import { HelpOutlineIcon } from 'element';
import {
  Box,
  Button,
  IconButton,
  Popover,
  Typography,
} from 'extended-oxygen-elements';
import { bindPopover, bindTrigger, usePopupState } from 'hooks';
import React from 'react';

export default function IconButtonClockInViolation() {
  const popupState = usePopupState();

  const handleCloseBtnClick = () => {
    popupState.close();
  };

  return (
    <>
      <IconButton {...bindTrigger(popupState)}>
        <HelpOutlineIcon />
      </IconButton>

      <Popover {...bindPopover(popupState)}>
        <Box p={3} maxWidth={540}>
          <Typography variant="h6">Clock on violation</Typography>

          <Typography>
            A violation is used to show the manager something unexpected has
            happened with the timesheet. A clock on violation can be configured
            to flag a timesheet for review if the employee has clocked on
            outside of the defined grace period.
          </Typography>

          <br />

          <Typography variant="h6">
            Example: Clock on violation = 5 minutes
          </Typography>

          <Typography>
            The shift start time is 9 AM and the employee clocks on at 9:06 AM.
            The shift is automatically flagged as a violation so the manager can
            review it.
          </Typography>

          <Box display="flex" justifyContent="flex-end" pt={3}>
            <Button variant="contained" onClick={handleCloseBtnClick}>
              Close
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
}
